<template>
  <div>
    <!-- Institute select input -->
    <div class="col-md-4 px-0" v-if="checkUser">
      <v-select
        auto-select-first
        filled
        :items="institutes"
        v-model="currentIns"
        @change="changeInstitute"
        item-text="name"
        item-value="id"
        :label="$t('instituteName')"
        color="green"
        item-color="green"
      ></v-select>
    </div>
    <!-- Feedback filters component -->
    <FeedbacksFilter
      :currentIns="currentIns"
      @resetSearch="resetSearch"
      @searchForData="searchForFeedbacks"
    />
    <!-- Feedback data table -->
    <v-data-table
      class="mt-5 students-list"
      :headers="tableHeaders"
      :items="feedbacks"
      item-key="id"
      :footer-props="{
        'show-current-page': true,
        showFirstLastPage: true,
        firstIcon: 'mdi-arrow-collapse-left',
        lastIcon: 'mdi-arrow-collapse-right',
        pageText: getPageLocation,
      }"
      :items-per-page="tableOptions.itemsPerPage"
      :server-items-length="totalFeedbacks"
      :no-data-text="noDataText"
      :page="tableOptions.page"
      :options="tableOptions"
      @update:options="updateFeedbacks"
      @click:row="viewFeedback"
      mobile-breakpoint="992"
    >
    </v-data-table>
    <!-- Feedback dialog -->
    <v-dialog
      transition="dialog-bottom-transition"
      max-width="900"
      v-model="feedbackDialog"
    >
      <v-card>
        <v-card-title>
          <span class="text-h5">
            Feedback details
          </span>
          <v-spacer></v-spacer>
          <v-btn
            class="mx-2"
            small
            color="primary"
            @click="feedbackDialog = false"
          >
            <v-icon dark>
              mdi-window-close
            </v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <form class="row">
            <div class="col-lg-4 py-0">
              <v-text-field
                v-model="feedbackDetails.feedback_id"
                :label="$t('feedbackID')"
                type="number"
                filled
                readonly
                color="green"
              ></v-text-field>
            </div>
            <div class="col-lg-4 py-0">
              <v-text-field
                v-model="feedbackDetails.reservation_id"
                :label="$t('reservationNumber')"
                type="number"
                filled
                readonly
                color="green"
              ></v-text-field>
            </div>
            <div class="col-lg-4 py-0">
              <v-text-field
                v-model="feedbackDetails.creator"
                :label="$t('Tutor') + ' / ' + $t('Student')"
                filled
                readonly
                color="green"
              ></v-text-field>
            </div>
            <div class="col-lg-4 py-0">
              <v-text-field
                v-model="feedbackDetails.feedback_creator_name"
                :label="$t('serviceRating')"
                filled
                readonly
                color="green"
              ></v-text-field>
            </div>
            <div class="col-lg-4 py-0">
              <v-text-field
                v-model="feedbackDetails.tutor_name"
                :label="$t('feedbackCreator')"
                filled
                readonly
                color="green"
              ></v-text-field>
            </div>
            <div class="col-lg-4 py-0">
              <v-text-field
                v-model="feedbackDetails.student_name"
                :label="$t('studentName')"
                filled
                readonly
                color="green"
              ></v-text-field>
            </div>
            <div class="col-lg-4 py-0">
              <v-text-field
                v-model="feedbackDetails.user_rating"
                :label="
                  feedbackDetails.feedback_type === 'student_feedback'
                    ? this.$t('tutorRating')
                    : this.$t('studentRating')
                "
                filled
                readonly
                color="green"
              ></v-text-field>
            </div>
            <div class="col-lg-4 py-0">
              <v-text-field
                v-model="feedbackDetails.service_rating"
                :label="$t('serviceRating')"
                filled
                readonly
                color="green"
              ></v-text-field>
            </div>
            <div class="col-lg-4 py-0">
              <v-text-field
                v-model="feedbackDetails.platform_rating"
                :label="$t('platformRating')"
                filled
                readonly
                color="green"
              ></v-text-field>
            </div>
            <div>
              <v-textarea
                v-model="feedbackDetails.comment"
                :label="$t('comment')"
                class="mt-5"
                outlined
                color="green lighten-1"
                data-testId="comment-input"
                auto-grow
                readonly
              ></v-textarea>
            </div>
          </form>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import GlobalMixin from "@/GlobalMixin.js";
import FeedbacksFilter from "../components/Dashboard/FeedbacksFilter.vue";

export default {
  name: "Feedbacks",
  mixins: [GlobalMixin],
  components: { FeedbacksFilter },
  data() {
    return {
      currentIns: null,
      institutes: [],
      userObj: JSON.parse(localStorage.getItem("vuex")),

      // Table Options
      tableOptions: {
        page: 1,
        offset: +this.$route.query.offset ? +this.$route.query.offset : 0,
        itemsPerPage: +this.$route.query.limit ? +this.$route.query.limit : 10,
      },
      // Search handling
      search: {},
      noDataText: "",

      feedbacks: [],
      totalFeedbacks: null,
      feedbackDialog: false,
      feedbackDetails: {},
    };
  },
  mounted() {
    // Get query params for the URL
    this.currentIns = +this.$route.query.ins
      ? +this.$route.query.ins
      : this.getInstituteId;
    // Call institutes in case of super admin
    if (this.userObj.auth.user.user.user_type === "operator")
      this.getAllInstitutes();
  },
  methods: {
    /**
     * Get all Institutes from the API
     */
    getAllInstitutes() {
      this.axios(`${process.env.VUE_APP_APIEndPoint}institutes/`, this.headers)
        .then(
          (res) =>
            (this.institutes = res.data.data.sort((a, b) =>
              a?.name.toLowerCase() > b?.name.toLowerCase() ? 1 : -1
            ))
        )
        .catch((err) => console.log(err));
    },
    /**
     * Change Institute
     */
    changeInstitute() {
      if (!this.currentIns) this.currentIns = 1;
      this.tableOptions.offset = 0;
      this.tableOptions.itemsPerPage = 10;
      this.tableOptions.page = 1;
      history.pushState(
        {},
        null,
        `${this.$route.path}?ins=${this.currentIns}&offset=${this.tableOptions.offset}`
      );
      this.resetSearch();
    },

    getFeedbacks(offset = 0, limit, search) {
      const body = {
        institute: this.currentIns,
        offset,
        limit,
        ...search,
      };

      this.axios
        .post(
          `${process.env.VUE_APP_APIEndPoint}reserve/list_feedback/`,
          body,
          this.headers
        )
        .then((res) => {
          this.feedbacks = res.data.data.data.map((feedback) => {
            return {
              ...feedback,
              creator:
                feedback.feedback_type === "student_feedback"
                  ? this.$t("Student")
                  : this.$t("Tutor"),
              comment: feedback.comment ? feedback.comment.substr(0, 10) + "..." : "N/A",
              fullComment: feedback.comment || "N/A"
            };
          });

          this.totalFeedbacks = res.data.data.pagination_data.count;
        })
        .catch((err) => this.formatErrors(err));
    },

    searchForFeedbacks(searchObj) {
      this.search = {};
      for (let key in searchObj) {
        if (key === "tutorName" && searchObj[key])
          this.search.tutor = searchObj[key];
        if (key === "studentName" && searchObj[key])
          this.search.student = searchObj[key];
        if (key === "feedbackCreator" && searchObj[key])
          this.search.feedback_type = searchObj[key];
        if (key === "courseType" && searchObj[key])
          this.search.course_type = searchObj[key];
        if (key === "programName" && searchObj[key])
          this.search.program = searchObj[key];
        if (key === "classesFromDate" && searchObj[key])
          this.search.class_from_datetime = searchObj[key] + " 00:00:00";
        if (key === "classesToDate" && searchObj[key])
          this.search.class_to_datetime = searchObj[key] + " 23:59:59";
        if (key === "feedbacksFromDate" && searchObj[key])
          this.search.feedback_from_datetime = searchObj[key] + " 00:00:00";
        if (key === "feedbacksToDate" && searchObj[key])
          this.search.feedback_to_datetime = searchObj[key] + " 23:59:59";
      }

      this.tableOptions.offset = 0;
      this.tableOptions.itemsPerPage = 10;
      this.tableOptions.page = 1;
      this.getFeedbacks(
        this.tableOptions.offset,
        this.tableOptions.itemsPerPage,
        this.search
      );
    },

    /**
     * Emits when one of the options properties is updated
     * @param options table info
     */
    updateFeedbacks(options) {
      if (!this.currentIns) this.currentIns = this.getInstituteId;
      // Get necessary values for table (itemsPerPage, page, offset)
      this.tableOptions.offset = options.itemsPerPage * (options.page - 1);
      this.tableOptions.itemsPerPage = options.itemsPerPage;
      this.tableOptions.page = this.tableOptions.offset
        ? this.tableOptions.offset / this.tableOptions.itemsPerPage + 1
        : 1;
      // Change URL without reloading the page
      history.pushState(
        {},
        null,
        `${this.$route.path}?ins=${this.currentIns}&offset=${this.tableOptions.offset}`
      );
      // Get updated students with new params
      this.getFeedbacks(
        this.tableOptions.offset,
        this.tableOptions.itemsPerPage,
        this.search
      );
    },
    /**
     * Reset search filter and reset table data
     */
    resetSearch() {
      this.tableOptions.offset = 0;
      this.tableOptions.itemsPerPage = 10;
      this.tableOptions.page = 1;
      this.search = {};
      this.getFeedbacks(
        this.tableOptions.offset,
        this.tableOptions.itemsPerPage,
        this.search
      );
    },

    viewFeedback(feedback) {
      this.feedbackDialog = true;
      this.feedbackDetails = {
        ...feedback,
        user_rating: feedback.user_rating + " ⭐",
        service_rating: feedback.service_rating + " ⭐",
        platform_rating: feedback.platform_rating + " ⭐",
        comment: feedback.fullComment
      };
      console.log(this.feedbackDetails);
    },
  },
  computed: {
    /**
     * Check if user is super admin or not
     */
    checkUser() {
      return this.userObj.auth.user.user.user_type === "operator";
    },
    /**
     * Track current page and all pages
     */
    getPageLocation() {
      const totalPages = Math.ceil(
        this.totalFeedbacks / this.tableOptions.itemsPerPage
      );
      return `Page ${this.tableOptions.page} of ${totalPages}`;
    },
    /**
     * @returns institute id depends on role of the user
     */
    getInstituteId() {
      return this.userObj.auth.user.user.user_type === "operator"
        ? 1
        : +this.userObj.auth.user.user.username.slice("").at(-1);
    },
    /**
     * Translations for table header
     * @returns []
     */
    // Table Data
    tableHeaders() {
      return [
        {
          text: this.$t("Tutor") + " / " + this.$t("Student"),
          value: "creator",
          sortable: false,
          align: "center",
        },
        {
          text: this.$t("studentName"),
          value: "student_name",
          sortable: false,
          align: "center",
        },
        {
          text: this.$t("tutorName"),
          value: "tutor_name",
          sortable: false,
          align: "center",
        },
        {
          text: this.$t("courseType"),
          value: "course_type",
          sortable: false,
          align: "center",
        },
        {
          text: this.$t("programName"),
          value: "program_name",
          sortable: false,
          align: "center",
        },
        {
          text: this.$t("classDate"),
          value: "class_start_date",
          sortable: false,
          align: "center",
        },
        {
          text: this.$t("feedbackDate"),
          value: "feedback_created_on_date",
          sortable: false,
          align: "center",
        },
        {
          text: this.$t("comment"),
          value: "comment",
          sortable: false,
          align: "center",
        },
      ];
    },
  },
};
</script>

<style lang="scss" scoped></style>
